export enum CONTACT_REQUEST_SOCKET_KEY {
    close = 'CloseRequest',
    accept = 'AcceptRequest',
    refuse = 'RefuseRequest',
    Withdrawal = 'Withdrawal',
    complete = 'CompleteRequest',
    refuseAds = 'RefuseAdsRequest',
    contactRequest = 'AddContactRequest',
}